import React, {ReactNode} from 'react';
import { NewtonsCradle } from 'ldrs/react'
import 'ldrs/react/NewtonsCradle.css'

interface LoaderProps {
    image?: string | null;
    message?: string | ReactNode | null;
    useNeutralLoader?: boolean;
    brandingLogo?: string | null;
}

export default function Loader ({ image = null, message = null, useNeutralLoader = false, brandingLogo = null } : LoaderProps) {
    return (
        <div className="flex flex-col items-center justify-center w-full" style={{height: '50vh'}}>
            {message ? <p className="text-center text-gray-700" style={{marginBottom: '-90px', marginLeft: '30px'}}>{message}</p> : null}
            {image ? (
                <img src={image} className={'h-96'} alt="Chargement..."/>
            ) : brandingLogo ? (
                <img
                    src={brandingLogo}
                    className={'max-w-[30%] h-auto animate-pulse-fade'}
                    alt="Chargement..."
                />
            ) : useNeutralLoader ? (
                <NewtonsCradle
                    size="120"
                    speed="1.4"
                    color="black"
                />
            ) : (
                <img src="/images/logo.gif" className={'h-96'} alt="Chargement..."/>
            )}
        </div>
    );
};
